import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";
import { userInfoWidth } from "@components/user-info/user-info";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Box } from "@mui-wrapper";
import { useMemo } from "react";

/** Number of rows to show in the left side */
const NUMBER_OF_ROWS = 4;

/**
 * Height for the user info component shown on the right side of the page.
 * This is used to calculate the empty page and skeletons
 */
const userInfoHeight = "443px";

/**
 * A skeleton loader for the member profile page
 */
export function MemberProfileSkeleton() {
  const $ = _c(14);
  const {
    isScreenMdOrLarger,
    isScreenSm,
    isScreenXs
  } = useMediaQueryList();
  let t0;
  bb0: {
    if (isScreenMdOrLarger) {
      t0 = "80px";
      break bb0;
    }
    if (isScreenSm) {
      t0 = "120px";
      break bb0;
    }
    if (isScreenXs) {
      t0 = "174px";
      break bb0;
    }
    t0 = undefined;
  }
  const infoBarHeight = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mt: "45px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== infoBarHeight) {
    t2 = <Skeleton variant="rectangular" width="100%" height={infoBarHeight} />;
    $[1] = infoBarHeight;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = isScreenMdOrLarger ? "row" : "column-reverse";
  const t4 = isScreenMdOrLarger ? "baseline" : "center";
  const t5 = isScreenMdOrLarger ? "15px" : "45px";
  let t6;
  if ($[3] !== t3 || $[4] !== t4 || $[5] !== t5) {
    t6 = {
      display: "flex",
      flexFlow: t3,
      alignItems: t4,
      pt: t5
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Box component="div" sx={{
      width: "100%"
    }}>{[...Array(NUMBER_OF_ROWS)].map(_temp)}</Box>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Skeleton variant="rectangular" width={userInfoWidth} height={userInfoHeight} sx={{
      minWidth: userInfoWidth
    }} />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t6) {
    t9 = <Box component="div" sx={t6}>{t7}{t8}</Box>;
    $[9] = t6;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t2 || $[12] !== t9) {
    t10 = <Box component="div" sx={t1}>{t2}{t9}</Box>;
    $[11] = t2;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  return t10;
}
function _temp(_, index) {
  return <Box component="div" key={index} sx={{
    pt: "37px",
    pr: "20px"
  }}><Skeleton variant="rectangular" height="54px" /></Box>;
}